import type { Move } from '../../../schemas/move';

/**
 * ***Gran Maestro Multiclasse*** — mossa comune oltre il 10° livello
 * (manuale V1 rr. 1817-1821). Richiede *Maestro Multiclasse*. 5° e ultimo
 * step della catena multiclasse comuni post-10°.
 *
 * Effetto: scegli una mossa **qualsiasi** di un'altra classe. Non prendere
 * mosse multiclasse. (Pool identico a Maestro; ultimo step della catena.)
 */
export const granMaestroMulticlasse: Move = {
  id: 'common.gran-maestro-multiclasse',
  name: 'Gran Maestro Multiclasse',
  type: 'common',
  trigger: 'Quando prendi questa mossa al level-up (oltre il 10° livello)',
  description: "Scegli una mossa qualsiasi da un'altra classe. Non prendere mosse multiclasse.",
  tags: ['multiclasse'],
  prerequisites: ['common.maestro-multiclasse'],
  replaces: [],
  multiclass: {
    picks: { kind: 'any-other-class' },
  },
};
